// extracted by mini-css-extract-plugin
export default {"bell":"BellLink_bell__46Rqd","bell_count":"BellLink_bell_count__qZiT3"};